export const CPF_RESPONSE = 'CPF_RESPONSE';
export const CPF_ERROR = 'CPF_ERROR';
export const CPF_DATA = 'CPF_DATA';
